import { Box, BoxProps, CheckBox, ColorOptions, ModalDialog, ModBox, Spacer, Text } from '@jfs/ui-new'
import { ButtonNew } from '../AdminButton'
import { FC, useState } from 'react'

interface ModalAlertProps {
  title: string
  message: string
  onPress?: () => void
  show: boolean
  onDismiss: () => void
  buttonTitle?: string
  isLoading?: boolean
  onCancel?: () => void
  cancelTitle?: string
  cancelButtonColor?: string
  positiveButtonColor?: string
  showHeader?: boolean
  height?: number
  width?: number
  isConfirmationCheckRequired?: boolean
  onCheckChange?: (isChecked: string) => void
}

const ModalAlertView: FC<ModalAlertProps> = (props: ModalAlertProps) => {
  const {
    title,
    message,
    onPress,
    show,
    onDismiss,
    buttonTitle,
    isLoading = false,
    onCancel,
    cancelTitle,
    cancelButtonColor,
    positiveButtonColor,
    showHeader = true,
    height = '100%',
    width = '100%',
    isConfirmationCheckRequired = false,
    onCheckChange,
  } = props

  const [isChecked, setChecked] = useState(false)
  const handleCancel = () => {
    onCancel && onCancel()
  }

  const onCheckBoxChange = (isSelected: string) => {
    setChecked(isSelected === 'true')
    onCheckChange && onCheckChange(isSelected)
  }
  const getModalView = () => {
    return (
      <>
        <ModBox {...styles.titleContainer} bg={'#f8f9fc' as ColorOptions} flexDirection={'row'} show={showHeader}>
          <Text fontFamily="jiotype-bold" color={'#214796' as ColorOptions} fontSize={16} title={title} />
          <ButtonNew
            onPress={handleCancel}
            color={cancelButtonColor ? cancelButtonColor : ('#e74a3b' as ColorOptions)}
            title={'Close'}
            borderRadius={4}
            height={30}
            underlayColor={'TRANSPARENT'}
            hoverColor={cancelButtonColor ? cancelButtonColor : ('#e74a3b' as ColorOptions)}
          />
        </ModBox>
        <Box {...styles.container}>
          <ModBox overflow={'auto'} h={height} w={width} show={!isConfirmationCheckRequired}>
            <Text type="h2Bold">{message}</Text>
          </ModBox>
          <ModBox show={isConfirmationCheckRequired} h={height} w={width}>
            <Text fontSize={16} fontFamily="jiotype-medium">
              {message}
            </Text>
            <Spacer direction="vertical" size={16} />
            <CheckBox
              textLabel={
                'I hereby make sure that all the documents are properly checked and Maker has committed document editing for all the relevant documents.'
              }
              textColor="BLACK_75"
              onChange={onCheckBoxChange}
              value={isChecked ? 'true' : 'false'}
            />
          </ModBox>
          <Spacer direction="vertical" size={24} />
          <Box flexDirection="row" alignSelf="flex-end">
            {onCancel && cancelTitle && (
              <>
                <ButtonNew
                  type="secondarySmall"
                  borderColor="WHITE"
                  shadowType="shadowSecondary"
                  title={cancelTitle}
                  onPress={onCancel}
                  isLoading={isLoading}
                />
                <Spacer direction="horizontal" size={16} />
              </>
            )}
            {buttonTitle && onPress && (
              <Box>
                <ButtonNew
                  type="primarySmall"
                  title={buttonTitle}
                  onPress={onPress}
                  isLoading={isLoading}
                  color={positiveButtonColor ? positiveButtonColor : ('#e74a3b' as ColorOptions)}
                  hoverColor={positiveButtonColor ? positiveButtonColor : ('#e74a3b' as ColorOptions)}
                  disabled={isConfirmationCheckRequired ? !isChecked : false}
                  // width={96}
                />
              </Box>
            )}
          </Box>
        </Box>
      </>
    )
  }

  return <ModalDialog show={show} onDismiss={onDismiss} children={getModalView()} type="CenteredWrap" />
}

export { ModalAlertView }

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  container: {
    backgroundColor: 'WHITE',
    padding: 20,
    borderRadius: 4,
  } as BoxProps,
  titleContainer: {
    ...shadow,
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 14,
    borderWidth: 1,
    borderRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: '#e3e6f0' as ColorOptions,
    backgroundColor: 'WHITE',
  } as BoxProps,
  cancelStyle: {
    padding: 16,
    borderRadius: 8,
    marginRight: 8,
    backgroundColor: 'PRIMARY',
    underlayColor: 'PRIMARY_STORNG',
  } as BoxProps,
}
